var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _radialGradient, _path5, _radialGradient2, _path6, _radialGradient3, _path7, _radialGradient4, _path8, _linearGradient4, _path9, _path10, _radialGradient5, _path11, _radialGradient6, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoleCustodians(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.13,
    x2: 17.927,
    y1: 28.551,
    y2: 41.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M17 29c-7.732 0-14 4.556-14 9.25v1c0 .966.784 1.75 1.75 1.75h24.5A1.75 1.75 0 0 0 31 39.25v-1c0-4.009-4.226-9.042-10.376-10.098-1.052-.18-2.495.848-3.624.848z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6a121",
    d: "M21 30.8c0 1.518-1.6 3.2-4 3.2s-4-1.682-4-3.2v-5.628h8V30.8z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 24.134,
    x2: 25.706,
    y1: 21,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M24.643 19h-1.132v4h1.282a.9.9 0 0 0 .892-.74l.295-1.703c.141-.814-.497-1.557-1.337-1.557z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 39.644,
    x2: 41.217,
    y1: 21,
    y2: 21,
    gradientTransform: "matrix(-1 0 0 1 49.51 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M9.357 19h1.132v4H9.207a.9.9 0 0 1-.892-.74l-.295-1.703C7.879 19.743 8.517 19 9.357 19z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -47.847,
    cy: 47.075,
    r: 9.508,
    gradientTransform: "translate(59.184 -21.07) scale(.8816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M17 10.867c-3.454 0-7 .525-7 7.992v5.209C10 26.733 14.2 30 17 30s7-3.267 7-5.932v-5.209c0-7.467-3.546-7.992-7-7.992z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -56.094,
    cy: 35.247,
    r: 25.074,
    gradientTransform: "translate(59.184 -21.07) scale(.8816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M17 9c-3.342 0-4 1-4 1-2 0-4.5 2.029-4.5 6 0 1.447.5 3 1.5 6 .477-5.727 1.467-9 3-9 1.108 0 1.614 1 4 1 2.015 0 2-1 4-1 2.625 0 3 8.097 3 9 1-3 1.5-4.736 1.5-6 0-4.004-3.067-7-8.5-7z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -74.451,
    cy: 36.317,
    r: 27.989,
    gradientTransform: "matrix(.8431 0 0 .8816 78.734 -21.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M17.066 8C13.423 8 13 10 13 10c-.037 1.014 0 2 0 2s.625 1.25 4.422 1.25C19.714 13.25 23 11.82 23 8h-5.934z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 30.789,
    cy: 21.449,
    r: 11.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#261103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#431d06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662c09"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M31 10.83c-8.814 0-11 14.232-11 14.232 0 2.534 1.177 4.754 3.641 5.342 2.11.504 4.766.971 7.359.971s5.248-.467 7.359-.971C40.823 29.816 42 27.595 42 25.062c0 0-2.186-14.232-11-14.232z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 28.113,
    x2: 31.911,
    y1: 28.556,
    y2: 41.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M31 29c-7.732 0-14 4.556-14 9.25v1c0 .966.784 1.75 1.75 1.75h24.5A1.75 1.75 0 0 0 45 39.25v-1C45 33.556 38.732 29 31 29z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6a121",
    d: "M35 32.8c0 1.518-1.6 3.2-4 3.2s-4-1.682-4-3.2v-5.628h8V32.8z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 171.042,
    cy: 14.963,
    r: 9.381,
    gradientTransform: "matrix(-.9136 0 0 .9667 187.256 6.067)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M31 10.062c3.454 0 7 .606 7 8.507v5.695C38 27.085 33.713 31 31 31s-7-3.915-7-6.736v-5.695c0-7.694 3.546-8.507 7-8.507z"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 24.979,
    cy: 7.42,
    r: 28.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M31 7c-4.54 0-5 3-5 3-1.846.272-6 .207-6 15 0 3.533 1.613 4.625 2.731 5.088C19.662 18.544 28.379 19.906 27 12c3.54 10.336 15.558 3.338 12.269 18.088C40.985 29.362 42 27.186 42 25c0-12.08-4.526-18-11-18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleCustodians);
export default __webpack_public_path__ + "static/media/roleCustodians.36989f82af5df4f5356cde91133359fd.svg";
export { ForwardRef as ReactComponent };